import { CommonModule } from '@angular/common';
import { Component, output, forwardRef } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

import { VOneButtonComponent } from '@shared-components';
import { IconType } from '@shared-enums';
import { LanguageSelectorComponent } from '@shared-layouts';

import { CompanySelectorComponent } from '../company-selector/company-selector.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    VOneButtonComponent,
    CompanySelectorComponent,
    forwardRef(() => LanguageSelectorComponent),
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  menuToggle = output<void>();

  readonly ICON_TYPE = IconType;

  onMenuToggle(): void {
    this.menuToggle.emit();
  }

  onHeaderKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      // Header container doesn't need specific action on Enter/Space
    }
  }
}
